<template>
  <v-dialog max-width="50%" v-model="dialog">
    <v-card min-width="500px">
      <v-card-actions class="ma-0 pa-0">
        <v-spacer></v-spacer>
        <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-actions dense class="ma-0 pa-0">
        <v-card width="100%" height="400px" elevation="0" outlined class="mx-3 mb-3" style="overflow-y: scroll">
          <v-card-actions>
            <v-progress-linear
              v-if="working"
              color="red"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
            <json-viewer
              style="width: 100%"
              v-if="jsonData != null"
              :value="jsonData"
              :expand-depth=10
              copyable
            ></json-viewer>

            <v-img
              v-if="imageData != null"
              :src="imageData"
              width="100%"
              contain
              height="350px"
            ></v-img>

            <code-highlight language="xml" v-if="xmlData">
              {{ xmlData }}
            </code-highlight>

          </v-card-actions>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import "vue-code-highlight/themes/prism.css";
import CodeHighlight from "vue-code-highlight/src/CodeHighlight.vue"

export default {
  name: "p-file-preview-popup",
  components: {CodeHighlight},
  data: () => ({
    dialog: false,
    jsonData: null,
    imageData: null,
    xmlData: null,

    working: false,
  }),
  computed: {},
  methods: {
    show(packageId, fileName) {

      this.dialog = true

      this.jsonData = null
      this.imageData = null
      this.xmlData = null

      this.working = true

      PackageStoreUtils.fethPackageFile(packageId, fileName)
        .then((data) => {
          this.working = false
          if (fileName.includes('.json')) {
            data[0].text().then((text) => {
              this.jsonData = JSON.parse(text)
            })
          }
          if (fileName.includes('.xml')) {
            data[0].text().then((text) => {
              this.xmlData = text
            })
          }
          if (fileName.includes('.png') || fileName.includes('.jpeg')) {
            let self = this
            let reader = new FileReader();
            reader.onload = function (e) {
              self.imageData = e.target.result
            };
            reader.readAsDataURL(data[0]);
          }
        })
        .catch((error) => {
          this.working = false
          this.$notify({title: 'Error get file!', text: error, type: "error"});
        })
    },
    hide() {
      this.dialog = false
    },
    onClose() {
      this.dialog = false
    }
  }
}
</script>
